export const fr_CA = {
    LEFT: 'Gauche: Déplacer la journée précédente.',
    RIGHT: 'Droite: se Déplacer à la prochaine journée.',
    DOWN: 'Vers le bas: passer à la ligne suivante.',
    UP: 'Vers le haut: passer à la rangée précédente.',
    PGUP: 'PgUp: Déplacer le mois précédent.',
    PGDOWN: 'PgDown: Déplacer le mois prochain.',
    HOME: 'À la maison: se Déplacer à l\'année précédente.',
    END: 'Fin: Déplacez-vous à l\'année prochaine.',
    ESC: 'Esc/aujourd\'Hui/Fermer: fermer le calendrier.',
    TITLE: 'Clavier Instructions'
};
